import { render, staticRenderFns } from "./CurriculumList.vue?vue&type=template&id=e7b92452&scoped=true"
import script from "./CurriculumList.vue?vue&type=script&lang=js"
export * from "./CurriculumList.vue?vue&type=script&lang=js"
import style0 from "./CurriculumList.vue?vue&type=style&index=0&id=e7b92452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b92452",
  null
  
)

export default component.exports